(function(){
  try{
    var main = document.querySelector('#MainContent') || document.querySelector('main.content-for-layout') || document.querySelector('main');
    var tmpl = main && main.getAttribute('data-template');
    if(!tmpl || tmpl.indexOf('index') !== 0) return; // homepage only
    if(document.querySelector('.rp-trust')) return;

    var CSS = ''
    + '.rp-trust{background:#0d0d0d;color:#fff;padding:56px 20px;}'
    + '.rp-trust__wrap{max-width:1100px;margin:0 auto;}'
    + '.rp-trust__tag{text-align:center;font-size:15px;line-height:1.6;color:#cfcfcf;max-width:760px;margin:0 auto 40px;}'
    + '.rp-trust__tag b{color:#ccff33;}'
    + '.rp-trust__cols{display:grid;grid-template-columns:1fr 1fr;gap:40px;}'
    + '.rp-trust__col h2{font-size:24px;font-weight:800;letter-spacing:-.01em;margin:0 0 16px;}'
    + '.rp-trust__col p{font-size:14.5px;line-height:1.7;color:#c7c7c7;margin:0 0 14px;}'
    + '.rp-trust__list{list-style:none;padding:0;margin:0;}'
    + '.rp-trust__list li{display:flex;align-items:flex-start;gap:10px;font-size:14.5px;line-height:1.5;color:#eaeaea;padding:9px 0;border-bottom:1px solid #232323;}'
    + '.rp-trust__list li:last-child{border-bottom:none;}'
    + '.rp-trust__list .ck{color:#ccff33;font-weight:900;flex:0 0 auto;}'
    + '@media(max-width:749px){.rp-trust__cols{grid-template-columns:1fr;gap:30px;}.rp-trust{padding:42px 18px;}.rp-trust__col h2{font-size:21px;}}';
    var st=document.createElement('style'); st.textContent=CSS; document.head.appendChild(st);

    var sec=document.createElement('section'); sec.className='rp-trust';
    sec.innerHTML=''
     + '<div class="rp-trust__wrap">'
     + '<div class="rp-trust__tag"><b>Premium running footwear</b>, hand-picked for runners who don’t compromise — comfort, speed and style in every pair.</div>'
     + '<div class="rp-trust__cols">'
     + '<div class="rp-trust__col">'
     + '<h2>About Running Premium</h2>'
     + '<p>Running Premium was built for people who love to run — and love great shoes. We bring together the latest drops and the icons from the world’s best brands: On, Nike, Hoka, Adidas, New Balance, Asics, Brooks, Saucony, Salomon and Puma — all in one place.</p>'
     + '<p>Every pair is <strong>100% authentic</strong> and checked before it leaves us. Whether you’re chasing a new personal best, training for your first race, or just want a clean premium pair for the street, you’ll find it here — at prices that finally make sense.</p>'
     + '</div>'
     + '<div class="rp-trust__col">'
     + '<h2>Why Runners Choose Us</h2>'
     + '<ul class="rp-trust__list">'
     + '<li><span class="ck">✔</span><span><strong>100% authentic</strong> — every pair verified, never fakes.</span></li>'
     + '<li><span class="ck">✔</span><span><strong>Secure, protected checkout</strong> — pay with confidence.</span></li>'
     + '<li><span class="ck">✔</span><span><strong>Free shipping</strong> on all orders, everywhere.</span></li>'
     + '<li><span class="ck">✔</span><span><strong>30-day easy returns</strong> — change your mind, no stress.</span></li>'
     + '<li><span class="ck">✔</span><span><strong>The best brands</strong>, hand-picked by real runners.</span></li>'
     + '<li><span class="ck">✔</span><span><strong>Fast, friendly support</strong> — a real human, quick replies.</span></li>'
     + '</ul>'
     + '</div>'
     + '</div>'
     + '</div>';

    var footer=document.querySelector('footer');
    if(footer && footer.parentNode){ footer.parentNode.insertBefore(sec, footer); }
    else if(main && main.parentNode){ main.parentNode.insertBefore(sec, main.nextSibling); }
    else document.body.appendChild(sec);
  }catch(e){ /* ne jamais casser la boutique */ }
})();
